import { render, staticRenderFns } from "./drawFont.vue?vue&type=template&id=2de4c139&scoped=true&"
import script from "./drawFont.vue?vue&type=script&lang=js&"
export * from "./drawFont.vue?vue&type=script&lang=js&"
import style0 from "./drawFont.vue?vue&type=style&index=0&id=2de4c139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de4c139",
  null
  
)

export default component.exports